module.exports = __webpack_public_path__ + "media/app/assets/specializations/warrior/fury-e3f417097f1a2794570a198968d652e1.png";